<template>
  <router-link tag="div" :to="{ name: 'cases', params: { filter: statusCase }}" class="flex justify-between items-center my-2 cursor-pointer"
               :class="{'text-primary': $route.params.filter === statusCase }">
    <div class="w-4/5 flex justify-between items-center mb-1">
      <div class="w-4/5 flex flex-row">
        <feather-icon :icon="icon" :svgClasses="[{'text-primary stroke-current': $route.params.filter === statusCase }, 'h-6 w-6']" />
        <span class="text-base xl:text-lg ml-1 xl:ml-3 truncate"> {{ statusText }}</span>
      </div>
    </div>

    <div class="w-1/5 flex justify-end" v-if="caseLen > 0">
      <vs-chip class="number px-1 mr-1" color="primary" v-if="caseLen > 0">
        {{ caseLen }}
        <span class="bg-danger text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center -top-8 -right-8" v-if="caseNtfLen > 0">
          {{ caseNtfLen }}
        </span>
      </vs-chip>
    </div>
  </router-link>
</template>

<script>
import {CASE_STATUS_REVISING} from "@/models/Case.model";

/**
 * Component used to create left filter menu, each item is one of status item
 */
export default {
  name: "filter-status-item",
  props: {
    statusText: {
      type: String,
      required: true
    },
    statusCase: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
  },
  computed: {
    caseLen() {
      let cases_status = [];
      if (this.statusCase === CASE_STATUS_REVISING) {
        cases_status = this.$store.state.Case.revisionCases();
      } else {
        cases_status = this.$store.state.Case.caseFilterActive(this.statusCase);
      }
      return cases_status.length;
    },
    caseNtfLen() {
      let cases_status = [];
      if (this.statusCase === CASE_STATUS_REVISING) {
        cases_status = this.$store.state.Case.revisionCases();
      } else {
        cases_status = this.$store.state.Case.caseFilterActive(this.statusCase);
      }

      let ntf = 0;
      for (let case_ of cases_status) {
        ntf += this.$store.getters['Notifications/getCaseUnseenNotification'](case_.id);
      }
      return ntf;
    }
  }
}
</script>

<style scoped>

</style>
